export const shoppingCartAction = {
  SAVEFARERULE: "SAVEFARERULE",
  SAVEBAGGAGEINFO: "SAVEBAGGAGEINFO",
  RESETFARERULEANDBAGGAGE: "RESETFARERULEANDBAGGAGE",
};